import React, {useContext} from 'react';
import * as R from 'ramda';
import {Row, Col, Card, CardBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {SystemConfigCtx} from '@/contexts';
import Form, {Select, Text, RadioGroup} from '@/Form';
import {
  buildSelectOptions,
  buildRadioOptions,
} from '@/components/Form/formHelper';
import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import styles from '@/b2b/index.module.css';
import {ReportStateProvider, useReportCtx} from '@/b2b/pages/Report/state';
import ExtendForms from '@/b2b/pages/Report/ExtendForms/index';
import ExportButton from '@/b2b/pages/Report/ExportButton';
import usePermission from '@/hooks/usePermission';

const WrappedReport = () => {
  const [producer] = useProducerCtx();
  const [report, dispatch] = useReportCtx();
  const formData = {
    ...report,
    manager: producer.producerFullName,
    selectedProducerId: producer.producerId,
  };

  const {t: tr} = useTranslation();
  const permission = usePermission();
  const {siteCode} = useContext(SystemConfigCtx);

  const reportList = R.compose(
    R.reject(([id]) =>
      R.and(
        R.equals(false, permission.canAccessTraningHistoryReport()),
        R.includes(id, [201])
      )
    ),
    R.reject(([id]) =>
      R.and(
        R.equals(false, permission.canAccessBvReport()),
        R.includes(id, [13, 14])
      )
    ),
    list => list[siteCode]
  )(tr('selection:report_type_options'));

  const setFormData = callback => {
    dispatch({type: 'updateFormData', data: callback});
  };

  return (
    <Form className={styles.search_box} stateHook={[formData, setFormData]}>
      <Card>
        <CardBody className={styles.search_box_body}>
          <Row>
            <Col md={10}>
              <Text name='manager' label={tr('consultant')} readOnly />
            </Col>
            <Col md={2}>
              <RadioGroup name='includedTeam' label={tr('included_team')}>
                {buildRadioOptions(
                  tr('selection:included_team'),
                  formData.includedTeam
                )}
              </RadioGroup>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Select name='reportType' label={tr('report:reports')}>
                <option value=''>{tr('please_select')}</option>
                {buildSelectOptions(reportList)}
              </Select>
            </Col>
          </Row>
          <ExtendForms reportType={formData.reportType} siteCode={siteCode} />
          <ExportButton formData={formData} />
        </CardBody>
      </Card>
    </Form>
  );
};

const Report = () => {
  const initialState = {
    includedTeam: 'true',
    reportType: '',
  };

  return (
    <ReportStateProvider initialState={initialState}>
      <WrappedReport />
    </ReportStateProvider>
  );
};

export default Report;
